export const ACTION_AUTH__REQUEST = 'ACTION_AUTH__REQUEST';
export const ACTION_AUTH__SUCCESS = 'ACTION_AUTH__SUCCESS';
export const ACTION_AUTH__FAIL = 'ACTION_AUTH__FAIL';

export const ACTION_LOGIN__REQUEST = 'ACTION_LOGIN__REQUEST';
export const ACTION_LOGIN__SUCCESS = 'ACTION_LOGIN__SUCCESS';
export const ACTION_LOGIN__FAIL = 'ACTION_LOGIN__FAIL';

export const ACTION_LOGOUT__REQUEST = 'ACTION_LOGOUT__REQUEST';
export const ACTION_LOGOUT__SUCCESS = 'ACTION_LOGOUT__SUCCESS';
export const ACTION_LOGOUT__FAIL = 'ACTION_LOGOUT__FAIL';

export const ACTION_ASK_UNSUSPEND__REQUEST = 'ACTION_ASK_UNSUSPEND__REQUEST';
export const ACTION_ASK_UNSUSPEND__SUCCESS = 'ACTION_ASK_UNSUSPEND__SUCCESS';
export const ACTION_ASK_UNSUSPEND__FAIL = 'ACTION_ASK_UNSUSPEND__FAIL';

export const ACTION_CHANGE_PASSWORD__REQUEST = 'ACTION_CHANGE_PASSWORD__REQUEST';
export const ACTION_CHANGE_PASSWORD__SUCCESS = 'ACTION_CHANGE_PASSWORD__SUCCESS';
export const ACTION_CHANGE_PASSWORD__FAIL = 'ACTION_CHANGE_PASSWORD__FAIL';

export const ACTION_DELETE_ACCOUNT__REQUEST = 'ACTION_DELETE_ACCOUNT__REQUEST';
export const ACTION_DELETE_ACCOUNT__SUCCESS = 'ACTION_DELETE_ACCOUNT__SUCCESS';
export const ACTION_DELETE_ACCOUNT__FAIL = 'ACTION_DELETE_ACCOUNT__FAIL';

export const ACTION_DELETE_NOTIFICATION__REQUEST = 'ACTION_DELETE_NOTIFICATION__REQUEST';
export const ACTION_DELETE_NOTIFICATION__SUCCESS = 'ACTION_DELETE_NOTIFICATION__SUCCESS';
export const ACTION_DELETE_NOTIFICATION__FAIL = 'ACTION_DELETE_NOTIFICATION__FAIL';
